import classes from "./CartButton.module.css";
import CartIcon from "./CartIcon";

function CartButton(props) {
  return (
    <button onClick={props.onClick} className={classes.button}>
      <span className={classes.icon}>
        <CartIcon />
      </span>
      <span>Call Now</span>
      <span className={classes.badge}></span>
    </button>
  );
}
export default CartButton;
